// @greenlight-spec: 29-app-environment-variables.md
// @greenlight-spec: decisions/0014-declarative-infra-spec-imperative-values.md
// Union of every name that could be derived as a managed env var per the
// derivation table in docs/29. Both `envSet` (runtime) and the manifest
// parser (PR-time) reject these names; the set is intentionally stable across
// whether the app currently has the resource that would inject the value.
export const RESERVED_ENV_NAMES = [
    'DATABASE_URL',
    // Legacy blob-credential names: no longer injected after the ADR-0059
    // cutover. They stay reserved so stale generated code fails on an unset
    // variable rather than a spoofable one.
    'STORAGE_ACCESS_URL',
    'STORAGE_ACCESS_TOKEN',
    'STORAGE_ENDPOINT',
    'STORAGE_CONTAINER_NAME',
    'STORAGE_OBJECT_PREFIX',
    // GCP-only: the Cloud SQL server CA the reconciler mounts as a file when a
    // postgres resource's provider supplies one (docs/39 §Cloud SQL for
    // PostgreSQL). Never set on Azure.
    'DATABASE_SERVER_CA_CERT',
    'STORAGE_SAS_URL',
    'AWS_ACCESS_KEY_ID',
    'AWS_SECRET_ACCESS_KEY',
    'AWS_SESSION_TOKEN',
    'GREENLIGHT_DATA_KEY',
    'GREENLIGHT_PROXY_URL',
    'GREENLIGHT_AI_KEY',
    'GREENLIGHT_AI_BASE_URL',
    'PORT',
    'PUBLIC_BASE_URL',
    'DEV_USER_EMAIL',
    'DEV_USER_GROUPS',
];
export const RESERVED_ENV_NAME_SET = new Set(RESERVED_ENV_NAMES);
//# sourceMappingURL=reserved-env-names.js.map